import { Pipe, PipeTransform } from '@angular/core';
import { LicenseCategory } from '../../common/models/LicenseCategory';

@Pipe({
  name: 'formatLicenseCategories',
  standalone: true,
})
export class FormatLicenseCategoriesPipe implements PipeTransform {
  transform(value: LicenseCategory[]): string {
    return value.map((data) => data.name).join(', ');
  }
}
